module.exports = __webpack_public_path__ + "static/media/ALIPAY.36729bd1.png";